module.exports = __webpack_public_path__ + "static/lights10-c08e68e0892a0d98eb0d9b8d0afc6c3c.jpg";